<template>
  <transition name="fade">
    <div class="userModal" v-if="show" v-on:click="showUserSelector = false">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="loading" v-if="loading"></div>
        <div class="close" v-on:click="close(false)"></div>
        <h4 v-if="isEdit">Edit Image Item</h4>
        <h4 v-else>Add Image Item</h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="formCnt">
            <div class="pdfCover" v-on:click="addImage">
              <div class="thePdf" v-if="media[lang]">
                <div class="mediaType" :class="media[lang].type"></div>
                <div class="coverImg" :style="{'background-image': `url(${cover[lang].imageMd})`}"
                  v-if="cover[lang]"/>
                <div class="coverImg" :style="{'background-image': `url(${media[lang].imageMd})`}"
                  v-else-if="media[lang].type === 'image'" :class="{contain: form.bgSize.model === 'contain'}"/>
                <div class="coverImg" :style="{'background-image': `url(${media[lang].thumb})`}"
                  v-else-if="media[lang].mimetype === 'video/youtube'"/>
                <div class="coverImg" :style="{'background-image': `url(${media[lang].mainThumb})`}"
                  v-else-if="media[lang].type === 'video'"/>
                <div class="pdfOption" v-if="media[lang].type === 'video'">
                  <div class="optBtn" v-on:click.stop="showPdfOptions = true"></div>
                  <div class="optOverlay" v-on:click.stop="showPdfOptions = false"
                    v-if="showPdfOptions"></div>
                  <div class="optCnt" v-if="showPdfOptions">
                    <li v-on:click="showPdfOptions = false">Change Media</li>
                    <li v-on:click.stop="customCover">Custom Cover Image</li>
                    <li v-on:click.stop="cover[lang] = null; showPdfOptions = false">
                      Reset Default Cover</li>
                  </div>
                </div>
              </div>
              <div class="addPdf" v-else>
                Add Media
              </div>
            </div>
            <div class="fieldGroup" v-if="media && media[lang] && media[lang].type === 'image'">
              <div class="fieldCnt">
                <label>Image Style</label>
                <select class="field" v-model="form.bgSize.model">
                  <option value="cover">Cover</option>
                  <option value="contain">Contain</option>
                </select>
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Title</label>
                <input type="text" class="field" placeholder="Content title..."
                  v-model="form.title[lang]">
              </div>
            </div>
            <div class="fieldGroup">
              <div class="fieldCnt">
                <label>Descriptions</label>
                <textarea rows="4" type="text" class="field" placeholder="Content descriptions..."
                  v-model="form.descriptions[lang]"></textarea>
              </div>
            </div>
            <div class="fieldGroup" :class="{fg2b: media && media[lang] && media[lang].type === 'image'}">
              <div class="fieldCnt" v-if="media && media[lang] && media[lang].type === 'image'">
                <label>Button Url</label>
                <input type="text" class="field" placeholder="https://..."
                  v-model="form.url.model">
              </div>
              <div class="fieldCnt">
                <label>Button Label</label>
                <input type="text" class="field" placeholder="Button label..."
                  v-model="form.buttonLabel[lang]">
                <div class="fieldHint">
                  <template v-if="media && media[lang] && media[lang].type === 'image'">
                    <!-- Button will not be displayed if url empty -->
                  </template>
                  <template v-else>
                    Button label to watch the video
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modalAction" :class="{_saveDisabled: !media.id || !media.en}">
            <div class="langSelectorBtn"
              v-on:click.stop="langSelectorOpen = !langSelectorOpen">
              <b>{{lang}}</b>
              <div class="langSelector" v-if="langSelectorOpen"
                v-on:click.stop="doNothing">
                <li v-on:click.stop="selectLang('en')">EN - English</li>
                <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
              </div>
            </div>

            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)" v-if="!saving">
              Cancel
            </button>
            <button class="btn btnPrimary" v-if="isEdit && !saving">
              Save Changes
            </button>
            <button class="btn btnPrimary" v-if="!isEdit && !saving">
              Add Item
            </button>
            <button class="btn btnPrimary saving" type="button" v-if="saving">
              Saving...
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
      <Confirmation ref="confirmDialog"/>
      <ColorPicker ref="colorPicker"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';
import ColorPicker from '@/components/ColorPicker.vue';

export default {
  components: { MediaSelector, Confirmation, ColorPicker },
  data() {
    return {
      isEdit: false,
      loading: false,
      show: false,
      saving: false,
      media: { id: null, en: null },
      cover: { id: null, en: null },
      showPdfOptions: false,
      form: {
        title: { id: '', en: '', error: null },
        descriptions: { id: '', en: '', error: null },
        buttonLabel: { id: '', en: '', error: null },
        url: { model: '', error: null },
        bgSize: { model: 'contain' },
      },
      langSelectorOpen: false,
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    open(d, n) {
      this.isEdit = d !== null;
      this.form.title.id = (d && d.title) ? d.title.id : '';
      this.form.title.en = (d && d.title) ? d.title.en : '';
      this.form.descriptions.id = (d && d.descriptions) ? d.descriptions.id : '';
      this.form.descriptions.en = (d && d.descriptions) ? d.descriptions.en : '';
      this.form.buttonLabel.id = (d && d.buttonLabel) ? d.buttonLabel.id : '';
      this.form.buttonLabel.en = (d && d.buttonLabel) ? d.buttonLabel.en : '';
      this.form.url.model = (d && d.url) ? d.url : '';
      this.form.bgSize.model = (d && d.bgSize) ? d.bgSize : 'contain';
      this.media.id = (d && d.media) ? d.media.id : null;
      this.media.en = (d && d.media) ? d.media.en : null;
      this.cover.id = (d && d.cover) ? d.cover.id : null;
      this.cover.en = (d && d.cover) ? d.cover.en : null;
      this.lang = 'id';
      this.next = n;
      this.show = true;
      this.saving = false;
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b, d) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    selectLang(lang) {
      this.lang = lang;
      this.langSelectorOpen = false;
    },
    setColor(field) {
      let color = this.form[field].model;
      if (!color && field === 'textColor') {
        if (this.form.type.model === 'imgBg') color = '#FFFFFF';
        else color = '#444444';
      }
      this.$refs.colorPicker.open({ color }, (b, c) => {
        if (!b) return;
        this.form[field].model = c;
      });
    },
    customCover() {
      this.showPdfOptions = false;
      this.$refs.mediaSelector.open({ type: 'image' }, (b, media) => {
        const m = media.gallery ? media.gallery[0] : media;
        if (m.status === 'processing') return;
        if (m.type !== 'image') {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support image for custom cover',
            error: true,
          });
          return;
        }
        if (b) this.cover[this.lang] = m;
      });
    },
    addImage() {
      this.$refs.mediaSelector.open(null, (b, media) => {
        if (!b) return;
        const m = media.gallery ? media.gallery[0] : media;
        if (m.status === 'processing') return;
        if (!['image', 'video'].includes(m.type)) {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support image or video for Two Image section.',
            error: true,
          });
          return;
        }
        this.cover[this.lang] = null;
        this.media[this.lang] = m;
      });
    },
    handleSubmit() {
      // if (this.saving || !this.media.id || !this.media.en) return;
      if (this.saving) return;
      const formData = {
        title: {
          id: this.form.title.id,
          en: this.form.title.en,
        },
        descriptions: {
          id: this.form.descriptions.id,
          en: this.form.descriptions.en,
        },
        buttonLabel: {
          id: this.form.buttonLabel.id,
          en: this.form.buttonLabel.en,
        },
        url: this.form.url.model,
        media: {
          id: this.media.id,
          en: this.media.en,
        },
        cover: {
          id: this.cover.id,
          en: this.cover.en,
        },
        bgSize: this.form.bgSize.model,
      };
      this.close(true, formData);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.pdfCover{
  height: 180px;
  background-color: #eee;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 24px;
  cursor: pointer;
  position: relative;
  .thePdf{
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    border-radius: 5px;
    .coverImg{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 5px;
      z-index: 1;
      &.contain{
        background-size: contain;
      }
    }
    .mediaType{
      position: absolute;
      left: 12px; bottom: 8px;
      width: 18px; height: 18px;
      z-index: 3;
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .96;
      &.image{
        background-image: url(../assets/mediatype/image-white.png);
      }
      &.video{
        background-image: url(../assets/mediatype/video-white.png);
      }
    }
    .pdfOption{
      position: absolute;
      right: 10px; top: 10px;
      z-index: 2;
      .optBtn{
        width: 34px; height: 34px;
        background-color: #fff;
        border-radius: 50%;
        position: relative;
        box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          position: absolute;
          content: "";
          left: 0; right: 0; top: 0; bottom: 0;
          background-image: url(../assets/more.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .optOverlay{
        position: fixed;
        left: 0; top: 0; right: 0; bottom: 0;
        cursor: default;
        z-index: 1;
      }
      .optCnt{
        position: absolute;
        right: 0; top: 100%;
        background-color: #fff;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        border-radius: 5px;
        padding: 10px 0;
        z-index: 2;
        li{
          list-style: none;
          padding: 6px 20px;
          cursor: pointer;
          font-size: 15px;
          white-space: nowrap;
          &.divider{
            background-color: #eee !important;
            height: 1px;
            padding: 0;
            margin: 5px 0;
          }
          &.red{
            color: red;
          }
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
    }
  }
  .addPdf{
    font-size: 20px;
    color: #888;
    padding-top: 50px;
    position: relative;
    transition: color .3s ease;
    &:before{
      top: 0; left: 0; right: 0;
      height: 40px;
      content: "";
      transition: opacity .3s ease;
      position: absolute;
      background-image: url(../assets/image-black.png);
      background-size: 40px auto;
      background-position: center top;
      background-repeat: no-repeat;
      opacity: .3;
    }
  }
  transition: background-color .3s ease;
  &:hover{
    background-color: #e5e5e5;
    .addPdf{
      color: #767676;
      &:before{
        opacity: .5;
      }
    }
  }
}

.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;

  .addCategory{
    color: #0245a7;
    display: inline-block;
    float: right;
    border-radius: 50px;
    margin-top: 4px;
    padding: 4px 10px 6px;
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    img{
      height: 18px;
      float: left;
      margin-right: 7px;
      margin-top: 1px;
    }
  }

  form{
    position: relative;
    .formCnt{
      max-height: 60vh;
      overflow: auto;
      border-top: #eee 1px solid;
      margin: 0 -60px;
      padding: 20px 60px 0;
      position: relative;
    }
  }

  .fieldGroup{
    &.fg2b{
      .fieldCnt:first-child{
        width: calc(62% - 10px);
      }
      .fieldCnt:last-child{
        width: calc(38% - 10px);
      }
    }
  }

  .fieldCnt{
    position: relative;
    .fieldLoading{
      position: absolute;
      right: 10px; top: 33px;
      z-index: 3;
      img{
        height: 24px;
      }
    }
    .theMan{
      position: relative;
      border-radius: 5px;
      border: #ccc 1px solid;
      display: flex;
      align-items: center;
      border-color: #0e5dd2;
      background-color: #e9f2ff;
      padding-left: 54px;
      padding-right: 38px;
      box-sizing: border-box;
      height: 48px;
      h5{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 17px;
        color: #0747a6;
        font-weight: 600;
        margin: 0;
      }
      .profilePict{
        width: 36px; height: 36px;
        position: absolute;
        left: 10px; top: 50%;
        margin-top: -18px;
        background-color: #0e5dd2;
        border-radius: 50%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &.email{
          background-color: #e9f2ff;
          background-image: url(../assets/envelope.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .close{
        position: absolute;
        right: 6px; top: 50%;
        border-radius: 50%;
        margin-top: -15px;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        opacity: .5;
        // transition: all .2s ease;
        &:hover{
          opacity: .8;
          background-color: #fff;
        }
      }
      &.hasError{
        background-color: #fff4f4;
        border-color: red;
        h5{
          color: red;
        }
        .profilePict{
          background-color: red;
          &.email{
            background-color: #fff4f4;
          }
        }
      }
    }
  }
  .fieldCnt.hasError{
    .field{
      border-color: red;
    }
    .fieldHint{
      display: none;
    }
    .fieldError{
      display: block;
    }
  }
  .fieldCnt.hasPrefix{
    position: relative;
    .field{
      padding-left: 40px;
    }
    .fieldPrefix{
      position: absolute;
      left: 10px; top: 35px;
      z-index: 3;
      color: #767676;
    }
  }

  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    transition: all .3s ease;
    width: 620px;
    box-sizing: border-box;
    padding: 30px 60px 40px;

    .pricingItem{
      margin-bottom: 26px;
      .loadingPackage{
        height: 100px;
        background-image: url(../assets/loading-2.svg);
        background-size: 40px auto;
        background-position: -4px 16px;
        background-repeat: no-repeat;
      }
      .pricingItemIn{
        cursor: pointer;
        border-radius: 10px;
        padding: 8px 10px 10px 40px;
        margin: 0 -10px 4px;
        // margin: 0 0 4px;
        position: relative;
        &:hover{
          background-color: #f5f5fe;
          .checkCnt{
            .checkIn{
              border-color: #666;
            }
          }
        }
      }
      .checkCnt{
        position: absolute;
        width: 30px; height: 30px;
        left: 4px; top: 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        .checkIn{
          width: 16px; height: 16px;
          box-sizing: border-box;
          border: #999 2px solid;
          border-radius: 3px;
          background-size: 18px auto;
          background-position: -2px -5px;
          background-repeat: no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &:hover{
          background-color: #e5e5e5;
          .checkIn{
            border-color: #444;
          }
        }
        &.radio{
          .checkIn{
            border-radius: 50%;
          }
        }
        &.checked{
          .checkIn{
            background-color: #0067ff;
            border-color: #0067ff !important;
            background-image: url(../assets/tick-white.png);
          }
          &.radio{
            .checkIn{
              background-color: #0067ff;
              border-color: #0067ff !important;
              background-image: none;
              &:before{
                content: "";
                position: absolute;
                width: 8px; height: 8px;
                border-radius: 50%;
                border: #fff 2px solid;
              }
            }
          }
        }
      }
      h4{
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 2px;
      }
      p{
        margin: 0;
      }
      .packageCnt{
        padding: 0 30px;
        color: #444;
        &.priceField{
          margin-bottom: 20px;
          label{
            margin-bottom: 6px;
          }
          .fieldCnt{
            // max-width: 300px;
          }
        }
        label{
          font-size: 14px;
          margin: 0 0 2px;
          display: block;
          text-transform: uppercase;
          color: #999;
          font-weight: bold;
        }
        .packageItem{
          padding: 8px 10px 10px 40px;
          margin: 0 -10px;
          border-radius: 5px;
          position: relative;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          h4{
            color: inherit;
            font-size: 18px;
          }
          .price{
            font-size: 18px;
            font-weight: bold;
            margin: 0 0 2px;
            span{
              font-weight: normal;
            }
          }
          p{
            color: inherit;
            opacity: .7;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
      &.notChecked{
        .packageCnt{
          opacity: .6;
          .fieldError{
            display: none;
          }
          .field{
            background-color: #e5e5e5;
            border-color: #d5d5d5;
          }
          .packageItem{
            cursor: default;
            background-color: #fff;
            .checkCnt{
              background-color: #fff;
              &.checked{
                .checkIn{
                  background-color: #999;
                  border-color: #999 !important;
                }
              }
            }
            h4, .price{
              color: #767676;
            }
          }
        }
      }
    }

    .loading{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #fff;
      background-color: rgba(255,255,255,.7);
      backdrop-filter: saturate(180%) blur(20px);
      background-image: url(../assets/loading-2.svg);
      background-position: center;
      background-size: 70px auto;
      background-repeat: no-repeat;
      z-index: 9;
    }
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      margin: 0;
      font-weight: 600;
      margin-bottom: 10px;
    }
    .modalAction{
      text-align: right;
      border-top: #eee 1px solid;
      margin: 0 -60px -40px;
      padding: 12px 30px;
      display: flex;
      align-items: center;
      .langSelectorBtn{
        margin-right: auto;
        position: relative;
        border-radius: 50px;
        padding: 6px 16px;
        padding-left: 36px;
        transition: all .3s ease;
        cursor: pointer;
        margin-right: auto;
        &:hover{
          background-color: #f5f5fe;
        }
        &:before{
          content: "";
          position: absolute;
          left: 12px; top: 0; bottom: 3px;
          width: 18px;
          background-image: url(../assets/language.png);
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
        b{
          font-weight: 600;
          text-transform: uppercase;
        }
        .langSelector{
          position: absolute;
          background-color: #fff;
          z-index: 7;
          bottom: 100%; left: 0;
          box-shadow: 0 0 6px rgba(0, 0, 0, .2);
          border-radius: 5px;
          padding: 8px 0;
          text-align: left;
          li{
            white-space: nowrap;
            list-style: none;
            padding: 8px 24px;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
      &.saveDisabled{
        .btnPrimary{
          background-color: #ccc;
          color: #999;
          box-shadow: none;
          cursor: default;
        }
      }
    }
    .btn{
      margin-left: 5px;
      &.saving{
        background-color: #ccc;
        color: #999;
        cursor: default;
        box-shadow: none;
      }
    }
  }
}
</style>
